import { ReleasePipelineSource } from '../../../../models/ReleasePipelineSource';

export function getReleasePipelineSourceTag(
    pipelineSource: number | undefined
): string {
    return pipelineSource === ReleasePipelineSource.YAML ? 'YAML' : 'Classic';
}
